function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Meldedialog",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  opacity: ".467"
}, /*#__PURE__*/React.createElement("g", {
  id: "Meldung-1a",
  transform: "translate(-313 -70)",
  fill: "#000"
}, /*#__PURE__*/React.createElement("g", {
  id: "suche",
  transform: "translate(13 44)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(300 26)",
  id: "Material/Icons-black/search"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.502 6.491h-.794l-.276.274A6.47 6.47 0 0113 10.991a6.5 6.5 0 11-6.5-6.5 6.47 6.47 0 014.225 1.566l.276-.274v-.792L15.999 0l1.491 1.491-4.988 5zm-6.002 0a4.5 4.5 0 100 9 4.5 4.5 0 000-9z",
  id: "Shape",
  transform: "matrix(1 0 0 -1 0 17.491)"
})))))));